module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Knarent Wypożyczalnia Narzędzi","short_name":"Knarent","start_url":"/","background_color":"#ffb600","theme_color":"#ffb600","display":"minimal-ui","icon":"src/images/logo_knarent.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"cc796f1f9342b87f7706f3cb3f6c13d2"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
